import { RoundingTypes } from '../types/rounding.types';

export interface IRegion {
  id: string;
  language: string;
  currency: string;
  regions: string[];
  rounding: RoundingTypes;
}
